import { render } from "./edit.vue?vue&type=template&id=da267cb4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=da267cb4&scoped=true&lang=scss"
import "./edit.vue?vue&type=style&index=1&id=da267cb4&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da267cb4"]])

export default __exports__